import Convertdec from 'decimal-number-to-words'
import { parseDateTime } from '/utils/date-time'

const FieldFormatter = (field) => {

  if (field) {

    if (field.type === "money") {
      const value = parseFloat(field.body)
      return value.toLocaleString('en-US', { style: 'currency', currency: field.currencyCode })
    }

    if (field.type == "number") {

      const value = parseFloat(field.body)

      switch (field.numberStyle) {
        case "PKNumberStyleDecimal": return value
        case "PKNumberStylePercent": return value * 100 + "%"
        case "PKNumberStyleScientific": return value.toExponential().replace("e+0", "E0")
        case "PKNumberStyleSpellOut": return Convertdec.toWords(value)
      }
    }

    if (field.dateStyle || field.timeStyle) {

      const dateValue = parseDateTime(field.body, field.ignoresTimeZone)

      if (!dateValue.isValid()) return "-"
  
      let formattedValue = ""

      if (field.dateStyle) {
        switch (field.dateStyle) {
          case "PKDateStyleNone": break
          case "PKDateStyleShort": formattedValue = dateValue.format("DD/MM/YY"); break
          case "PKDateStyleMedium": formattedValue = dateValue.format("DD MMM YYYY"); break
          case "PKDateStyleLong": formattedValue = dateValue.format("DD MMMM YYYY"); break
          case "PKDateStyleFull": formattedValue = dateValue.format("dddd DD MMMM YYYY"); break
        }
      }

      if (field.dateStyle && field.dateStyle !== "PKDateStyleNone" && field.timeStyle && field.timeStyle !== "PKDateStyleNone") {
        formattedValue += ", "
      }

      if (field.timeStyle) {
        switch (field.timeStyle) {
          case "PKDateStyleNone": break
          case "PKDateStyleShort": formattedValue += dateValue.format("HH:mm"); break
          case "PKDateStyleMedium": formattedValue += dateValue.format("HH:mm:ss"); break
          case "PKDateStyleLong": formattedValue += dateValue.format("HH:mm:ss") + " GMT"; break // GMT
          case "PKDateStyleFull": formattedValue += dateValue.format("HH:mm:ss") + " Greenwich Mean Time"; break // Greenwich Mean Time
        }
      }

      return formattedValue
    }

    return field.body
  }
}

export default FieldFormatter
